import React from "react";
import styled from "styled-components";
import Hugged from "../../utils/images/hugged.jpg";
import { HeartFilled } from "@ant-design/icons";
import { HeartStyle } from "../data/data";

const Layout = styled.div`
  background: #f6f6f6;
  padding-top: 30px;
  .pics {
    display: grid;
    place-items: center;
  }
  .pics img {
    width: 100%;
    height: 459px;
    object-fit: cover;
    @media (max-width: 767px) {
      height: 220px;
    }
  }
  .wrap {
    display: grid;
    place-items: center;
  }
  .title {
    font-size: 30px;
    font-family: "Oswald" sans-serif;
    text-transform: uppercase;
    color: #333;
  }
  .content {
    padding: 0 7% 0 7%;
    text-align: center;
    @media (max-width: 767px) {
      padding: 0 3%;
    }
  }
  p {
    padding: 20px 0;
    font-size: 16px;
    @media (max-width: 765px) {
      text-align: justify;
      padding: 12px 0;
      font-size: 120%;
    }
  }
`;
function Accept() {
  return (
    <>
      <Layout>
        <div>
          <div className="wrap">
            <h3 className="title">she huged him</h3>

            <div style={{ padding: 13 }}>
              <HeartStyle>
                <span className="white-line"></span>
                <HeartFilled
                  style={{ fontSize: 19, zIndex: 20, color: "red" }}
                />
                <HeartFilled
                  style={{
                    fontSize: 19,
                    marginLeft: -5,
                    color: "white",
                  }}
                />
                <span className="white-line"></span>
              </HeartStyle>
            </div>
          </div>
          <div className="content">
            <div>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
                eiusmod tempor incididunt <br /> ut labore et dolore magna
                aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                <br /> ullamco laboris nisi ut aliquip ex ea commodo
              </p>
            </div>
            <div className="pics">
              <img src={Hugged} alt="huged" />
            </div>
            <div style={styles.text}>
              <span>AND SAID </span>"<span style={{ color: "red" }}>YES</span>!"
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}

const styles = {
  title: {
    fontSize: 40,
    fontWeight: 700,
    textTransform: "uppercase",
  },

  text: {
    fontSize: 35,
    fontWeight: "bold",
    textAlign: "center",
    fontFamily: "sans-serif",
    textTransform: "uppercase",
    padding: "50px 0",
  },
};

export default Accept;
